import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TuiAccordion } from '@taiga-ui/kit';
import { ComponentsModule } from '@src/app/components';
import { SharedModule } from '@src/app/shared';

import { FaqComponent } from './faq.component';

@NgModule({
  declarations: [FaqComponent],
  imports: [CommonModule, ComponentsModule, ReactiveFormsModule, SharedModule, ...TuiAccordion],
  exports: [FaqComponent],
})
export class FaqModule {}
